import React from "react";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import swal from "sweetalert";
import Grid from "@material-ui/core/Grid";
import Tooltip from "@material-ui/core/Tooltip";
import InfoIcon from "@material-ui/icons/Info";
import imgUrl from "../../assets/images/imageUrl";
import ApiServices from "../../api/api";
import { logError } from "../../helpers/auth";
const reactStringReplace = require("react-string-replace");

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    maxWidth: "36ch",
    backgroundColor: theme.palette.background.paper,
  },
  inline: {
    display: "inline",
  },
}));

function ServicesList(props) {
  const { t } = props;
  const { templateID } = props;
  let colorStyles = templateID == 2 ? { color: props.componentbgcolor } : {};

  const classes = useStyles();
  let history = useHistory();
  const [open, setOpen] = React.useState(false);
  let substrings = [
    "access",
    "available",
    "acceptable",
    "quality",
    "privacy",
    "discriminated",
    "stigmatized",
  ];

  var imurl = props.serviceObj.iconUrl ? getHttpsUrl(props.serviceObj.iconUrl) : imgUrl.qaulity;



  const [imgurl, setUrl] = React.useState(imurl);

  function getHttpsUrl(iconurl) {
    var spliurtl = iconurl.split("://")
    let myUrl = null;
    if(spliurtl){
      myUrl = spliurtl.length > 1 ? "https://" + spliurtl[1] : "https://" + spliurtl[0];
    }
    return myUrl;
  }

  function handleClick() {
    //console.log("handleClick>>", props);
    if (props.serviceObj.timeActive) {
      //getReportList()
      goToServiceForm()
    } else {
      goToServiceForm()
    }
  }


  function goToServiceForm() {
    console.log("handleClick>>", props);
    history.push({
      pathname: "/layout/ServiceForm",
      state: props.serviceObj,
    });
  }

  function getReportList() {
    if (navigator.onLine) {
      var param = {
        communityId: props.serviceObj.communityId,
        languageId: props.languageId,
        userId: JSON.parse(localStorage.getItem('obj')).userId
      };
      ApiServices.getCaseListForService(param).then((res) => {
        try{
          
          console.log(res.data.status)
          if (res.data.status == 200 && Object.keys(res.data.data.caseList) && Object.keys(res.data.data.caseList).length != 0) {
            checkserviceIsPresent(res.data.data.caseList)
          } else {
            goToServiceForm()
          }
        }catch(err){
          console.log("err::", err)
          var errorObj = {
            component: 'ServicesList',
            method: 'getReportList',
            error: err
          }
          logError(errorObj);
        }
      });
    } else {
      goToServiceForm()
    }
  }

  function checkserviceIsPresent(caseList) {
    console.log(caseList)
    for (var key in caseList) {
      if (caseList.hasOwnProperty(key)) {
        var check = caseList[key].filter(obj => obj.serviceId == props.serviceObj.id)
        
        if (check && check.length > 0) {
          var today = new Date()
          var submittedoday = new Date(check[0].createdDate)
          // To calculate the time difference of two dates 
          var Difference_In_Time = today.getTime() - submittedoday.getTime();
          // To calculate the no. of days between two dates 
          var Difference_In_Days = Math.round(Difference_In_Time / (1000 * 3600 * 24));
          let flag = checkTimediff(Difference_In_Days)
          if (flag) {
            goToServiceForm()
          } else {
            swal({
              text: t("We would like to inform you that this issue has been already reported into the system and our team would get in touch with you shortly"),
              icon: "warning",
              button: t("ok"),
            })
          }
        } else {
          goToServiceForm()
        }
      }
    }
  }


  function checkTimediff(Difference_In_Days) {
    if (props.serviceObj.timeUnit == "Week") {
      var cond = 7 * Number(props.serviceObj.timeValue);
      return Difference_In_Days > cond ? true : false;
    } else if (props.serviceObj.timeUnit == "Day") {
      var cond = 1 * Number(props.serviceObj.timeValue);
      return Difference_In_Days > cond ? true : false;
    } else if (props.serviceObj.timeUnit == "Month") {
      var cond = 30 * Number(props.serviceObj.timeValue);
      return Difference_In_Days > cond ? true : false;
    } else {
      return false;
    }
  }


  const handleTooltipClose = () => {
    setOpen(false);
  };

  const handleTooltipOpen = () => {
    setOpen(true);
  };

  function boldString(str, substr) {
    substrings.some(function (v) {
      if (str != null && str.indexOf(v) >= 0) {
        str = reactStringReplace(str, v, (match, i) => (
          <span className="fw-600">{match}</span>
        ));
      }
    });
    return str;
  }

  return (
    <Grid
      key={props.serviceObj.id}
      container
      spacing={0}
      className="gridcontainer chatuserlistdiv borderbottomgrey"
    >
      <Grid item xs={2} className="zero">
        <p className="zero color-green text-center forumicon">
          <img src={imgurl} className="serviceImg" />
        </p>
      </Grid>
      <Grid item xs={10} className="zero">
        <div className="zero chatusername"  style={colorStyles}>
          <span className="servicename itemName" onClick={handleClick}>
            {boldString(props.serviceObj.name)}
          </span>
          {
            props.serviceObj.description && (
              <span className="servicename">
                <Tooltip
                  open={open}
                  onClose={handleTooltipClose}
                  title={props.serviceObj.description}
                  arrow
                  placement="top"
                >
                  <InfoIcon onClick={handleTooltipOpen} style={{ fill: props.componentbgcolor }} />
                </Tooltip>
              </span>
            )
          }
        </div>
      </Grid>
      {/* <Grid item xs={3} className="zero">
        <p className="text-center unreadmsgicon reportmiddle">
          <span className="unreadnoticon">{props.serviceObj.openCount}</span>
          <Badge showZero badgeContent={props.serviceObj.resolvedCount} color="primary">
            <MailIcon />
          </Badge>
        </p>
      </Grid> */}
    </Grid>
  );
}



const mapStateToProps = (state) => {
  let { storeState } = state;
  return {
    templateID: JSON.parse(localStorage.getItem('templateID')) != null ? JSON.parse(localStorage.getItem('templateID')) : storeState.templateID,
    communityuid: storeState.communityId,
    langId: storeState.langId,
    componentbgcolor: storeState.componentbgcolor
  };
};



const transServicesList = withTranslation()(ServicesList);
export default connect(mapStateToProps, {})(transServicesList);